import type { ColDef } from "ag-grid-enterprise";
import { getColumnFiltersByType } from "./getColumnFiltersByType";

/**
 * Give each column the filter its type deserves — text/set for strings,
 * number/set for numerics — so a grid's filters tool panel has something in
 * it. Applied to every column that doesn't name a filter itself, not a chosen
 * few: a modal built for slicing one context has no column worth leaving
 * inert.
 *
 * Columns that already say what they want keep it — an explicit filter keeps
 * its own `filterParams` rather than inheriting the multi-filter's, and
 * `filter: false` (images, sparklines, a column the database cannot filter) is
 * a choice too. A typeless column gets nothing.
 *
 * Applied per column def rather than through `gridOptions.defaultColDef`:
 * `DataTable` shallow-spreads consumer grid options, so overriding that key
 * would drop ui-kit's own defaults with it.
 */
export function withTypeFilters<TData>(
  columns: ColDef<TData>[]
): ColDef<TData>[] {
  return columns.map((column) =>
    column.filter !== undefined || typeof column.type !== "string"
      ? column
      : { ...column, ...(getColumnFiltersByType(column.type) ?? {}) }
  );
}
